export default __webpack_public_path__ + "assets/Überweisung_Logo_it.svg";